export default __webpack_public_path__ + "static/media/latest3.4cfe6a63.png";